import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';

import {Subscription} from 'rxjs';

import {EntitiesComponent} from '../../../entities.component';

import {LoginService} from '../../../../pages/login/login.service';
import {ItemsService as OrganizationService} from '../../../customer/system/organization-info';
import {UserService} from '../../../../shared/service/user.service';
import {AuthService} from '../../../../shared/service/auth.service';
import {AppSubject} from '../../../../shared/app-subject';
import {Severity, ToastService} from '../../../../shared/components/toast/toast.service';
import {Col} from '../../../../shared/model';
import {LazyLoadEvent} from 'primeng-lts/api';
import {environment} from '../../../../../environments/environment.prod';
import {MenuItem} from 'primeng-lts/api';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {

  AuthService = AuthService;
  baseWebSocketURL: string = environment.baseWebSocketURL;
  @Input() actionColumnWidth?: number;

  @Input() onMessage: () => void = () => {
  };
  @Input() selectionMode: string = 'single';
  selectedItem: any;

  user: any;
  displayName?: string;
  displayQR?: boolean;
  QRdata: any

  decreeAndCircularUsing?: string;

  changingPassword?: boolean;
  passwordWarningVisible = false;
  openPasswordAfterWarning = false;
  productList?: boolean;
  submittedPassword?: boolean;
  changePasswordForm = this.fb.group({
    oldPassword: ['', Validators.required],
    newPassword: ['', Validators.required],
    newPasswordVerify: ['', Validators.required]
  });
  changePasswordError?: string;

  decreeCircularSubscription?: Subscription;
  items: Array<any> = new Array<any>();
  totalRecords: number = 0;
  webSocket?: WebSocket;
  listening?: boolean;
  isSuccess?: boolean;
  title?: string;
  paymentDone?: boolean;
  paymentSuccessVisible?: boolean;
  amount?: number;
  paymentRefNum?: string;
  merchantName?: string;
  paymentInfoVisible?: boolean;
  currentPaymentItem?: any;
  paymentInfoForm = this.fb.group({
    orgRepName: ['', Validators.required],
    contactNumber: ['', Validators.required],
    emailAddress: ['', [Validators.required, Validators.email]]
  });
  mobileAppMenuItems: MenuItem[] = [];
  notifications?: Array<any>;
  notification: any;
  titleText?: string;
  noticeCount?: number;


  constructor(
    private fb: FormBuilder,
    private router: Router,
    public entities: EntitiesComponent,
    private loginService: LoginService,
    private organizationService: OrganizationService,
    private toastService: ToastService
  ) {
  }

  cols: Array<Col> = [
    {width: 100, field: 'pseudoId', header: 'Mã gói', type: 'text', matchMode: 'contains', format: 'text', visible: true},
    {width: 100, field: 'productName', header: 'Tên gói', type: 'text', matchMode: 'contains', format: 'text', visible: true},
    {width: 100, field: 'amountValue', header: 'Số lượng', type: 'text', matchMode: 'contains', format: 'text', visible: true},
    {width: 100, field: 'price', header: 'Đơn giá', type: 'text', matchMode: 'contains', format: 'text', visible: true},
  ];

  ngOnInit(): void {
    this.user = UserService.getUser();
    this.passwordWarningVisible = this.user.hasChangePassword === true &&
      UserService.get(UserService.KEY.PASSWORD_WARNING_DISMISSED) !== 'Y';
    this.decreeCircularSubscription = AppSubject.getDecreeCircular().subscribe((decreeCircular) => {
      this.decreeAndCircularUsing = decreeCircular;
    });
    if (AuthService.hasRoles(['Customer'])) {
      this.loadDecreeCircular();

      this.displayName = this.user.partyTaxId;
    } else {
      this.displayName = this.user.partyName;
    }
    this.initWebSocket();
    this.getNotificationCount();

    this.mobileAppMenuItems = [
      {
        label: 'Link tải Android',
        icon: 'pi pi-android',
        command: () => {
          window.open('https://play.google.com/store/apps/details?id=com.homecastainvoice.app', '_blank');
        }
      },
      {
        label: 'Link tải iOS',
        icon: 'pi pi-apple',
        command: () => {
          window.open('https://apps.apple.com/us/app/homecasta-invoice/id6749284662', '_blank');
        }
      }
    ];
  }

  initWebSocket(): void {
    const origin = location.origin.replace('http', 'ws').replace('https', 'wws');
    this.webSocket = new WebSocket(`${origin}/${this.baseWebSocketURL}`);
    this.webSocket.addEventListener('open', () => {
      this.webSocket?.send('subscribe:NapasPaymentResult');
      this.webSocket?.send('subscribe:CustomerNotification');
      this.webSocket?.send('subscribe:GeneralNotification');
    });

    this.webSocket.onclose = (e) => {
      if (e.reason !== 'unmount') {
        this.initWebSocket();
      }
    }
    this.webSocket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.topic === 'NapasPaymentResult') {
        if (this.onMessage) {
          this.onMessage();
        }
        if (this.listening) {
          this.listening = false;
          this.paymentDone = true;
          this.displayQR = false;
          this.paymentSuccessVisible = true;
          if (data.showAlert === true) {
            this.isSuccess = true
            this.title = data.title
          } else {
            this.isSuccess = false
            this.title = 'C\u00f3 l\u1ed7i x\u1ea3y ra!';
          }
        }
      }
      if (['CustomerNotification', 'GeneralNotification'].includes(data.topic)) {
        this.getNotificationCount();
      }
    }
  }


  ngOnDestroy(): void {
    if (this.decreeCircularSubscription) {
      this.decreeCircularSubscription.unsubscribe();
    }
    if (this.webSocket) {
      this.webSocket.close(3010, 'unmount');
    }

  }

  loadDecreeCircular(): void {
    this.organizationService.get().subscribe((response) => {
      if (response && response.decreeAndCircularUsing) {
        AppSubject.setDecreeCircular(response.decreeAndCircularUsing);
      }
    });
  }
  setSelectedItem(rowData: any): void {
    this.selectedItem = rowData;
  }
  toggleDecreeCircular(): void {
    this.organizationService.toggleDecreeCircular().subscribe(() => {
      this.loadDecreeCircular();
    });
  }

  changePassword(): void {
    this.changePasswordForm.reset();
    this.changingPassword = true;
  }

  dismissPasswordWarning(): void {
    this.passwordWarningVisible = false;
    UserService.set(UserService.KEY.PASSWORD_WARNING_DISMISSED, 'Y');
    if (this.openPasswordAfterWarning) {
      this.openPasswordAfterWarning = false;
      this.changePassword();
    }
  }

  openPasswordChangeFromWarning(): void {
    this.openPasswordAfterWarning = true;
    this.passwordWarningVisible = false;
  }

  showProductList(): void {
    this.loadLazy({first: 0, rows: 10, filters: {}})
    this.productList = true;
    this.title = ''
    this.paymentDone = false
    this.paymentSuccessVisible = false;
  }

  loadLazy(event: LazyLoadEvent): void {
    this.organizationService.getProductList().subscribe((response) => {
      this.totalRecords = response?.totalRecords;
      this.items = response?.listData;
      this.initActions();
    })
  }

  initActions(): void {
    if (this.items && this.items.length) {
      this.items.forEach((item) => {
        item.actions = [
          {icon: 'pi pi-check', styleClass: 'p-button-success', title: 'Thanh toán', command: () => this.doPayment(item)}
        ];
      });
    }
  }
  openPaymentInfo(item: any): void {
    this.currentPaymentItem = item;
    this.paymentInfoForm.reset();
    if (this.user) {
      this.paymentInfoForm.patchValue({
        orgRepName: this.user.orgRepName || '',
        contactNumber: this.user.contactNumber || '',
        emailAddress: this.user.emailAddress || ''
      });
    }
    this.paymentInfoVisible = true;
  }

  confirmPayment(): void {
    if (this.paymentInfoForm.invalid || !this.currentPaymentItem) {
      return;
    }

    const formValue = this.paymentInfoForm.value;
    const params = {
      productId: this.currentPaymentItem.productId,
      orgRepName: formValue.orgRepName,
      contactNumber: formValue.contactNumber,
      emailAddress: formValue.emailAddress
    };

    this.organizationService.initPayment(params).subscribe((response) => {
      this.handlePaymentResponse(response);
    });
  }

  handlePaymentResponse(response: any): void {
    if (response.vietQRImageBase64) {
      this.paymentInfoVisible = false;
      this.displayQR = true;
      this.productList = false;
      this.QRdata = response.vietQRImageBase64;
      this.amount = response.amountValue;
      this.paymentRefNum = response.napasOrderId;
      this.merchantName = response.merchantName;
      this.paymentDone = false;
      this.listening = true;
    }
  }

  doPayment(item: any): void {
    this.openPaymentInfo(item);
  }

  onChangePassword(): void {
    if (!this.submittedPassword && this.changePasswordForm.valid) {
      this.submittedPassword = true;
      this.changePasswordError = '';

      this.loginService.changePassword(this.changePasswordForm.value).subscribe(({isSuccess, messages}) => {
        this.submittedPassword = false;
        if (isSuccess === 'Y') {
          this.toastService.setMessage({severity: Severity.SUCCESS, detail: messages});
          this.changingPassword = false;
          this.loginService.getMe().subscribe((user) => {
            if (user?.roleTypeId) {
              UserService.setUser(user);
              this.user = user;
              this.passwordWarningVisible = false;
            }
          });
        } else {
          this.changePasswordError = messages;
        }
      }, () => {
        this.submittedPassword = false;
      });
    }
  }

  getNotificationCount(): void {
    this.organizationService.getCount().subscribe(data => {
      this.noticeCount = data?.noticeCount;
    });
  }

  viewNotification(event: any): void {
    this.entities.onTopbarActionClick(event, 'Notification');

    this.organizationService.markTouched().subscribe(() => this.getNotificationCount());

    const escape = document.createElement('div');

    this.organizationService.getNotifications().subscribe(({listData}) => {

      listData.forEach((item: any) => {
        escape.innerHTML = item.titleText;
        item.titleText = escape.innerText;
      });
      this.notifications = listData;
    });
  }

  viewNotificationDetail(notification: any): void {
    this.notification = notification;
    this.titleText = notification.titleText
  }

  logout(): void {
    this.loginService.logout().subscribe(() => {
      this.router.navigateByUrl('/login').then();
    });
  }

}
